import { Typography, IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ExpenseInfo = ({ expenseTitle, infoText }) => {
    return (
        <div className="d-flex align-items-center gap-1">
            <span className="text-gray fsize-16 font-semibold">
                {expenseTitle}
            </span>
            <Tooltip title={infoText} arrow placement="top">
                <IconButton size="small" >
                    <InfoOutlinedIcon fontSize="small" sx={{ color: 'gray' }} />
                </IconButton>
            </Tooltip>
        </div>
    )
}
export default ExpenseInfo;